// extracted by mini-css-extract-plugin
module.exports = {"mask":"_5D10fqse","loader":"_5D5oeGH9"};